import React from 'react';
import RemoteText from "../common/remoteText"

export function Acknowledgement() {
  return (
    <div className="container mx-auto">
      <div className="my-2 text-sm text-avenue-iron-500">
        <p>
          <RemoteText name="AcknowledgementOfCountry" />
        </p>
      </div>
    </div>
  )
}
